<template>
  <PVForm
    ref="formRef"
    v-slot="$form"
    class="create-supplier-token-form"
    :initial-values="initialValues"
    :resolver="resolver"
    @submit="onFormSubmit"
  >
    <PVFormField :name="'name'">
      <label for="name">{{ $t('supplierAuthTokens.name') }} *</label>
      <PVInputText fluid name="name"></PVInputText>
      <PVMessage v-if="$form.name?.invalid" severity="error" variant="simple">
        {{ $form.name.error.message }}
      </PVMessage>
    </PVFormField>
    <PVFormField :name="'expiresInDays'">
      <label for="expiresInDays"
        >{{ $t('supplierAuthTokens.expirationDays') }} *</label
      >
      <PVInputNumber fluid name="expiresInDays"></PVInputNumber>
      <PVMessage
        v-if="$form.expiresInDays?.invalid"
        severity="error"
        variant="simple"
      >
        {{ $form.expiresInDays.error.message }}
      </PVMessage>
    </PVFormField>
  </PVForm>
</template>

<script setup lang="ts">
  import { zodResolver } from '@primevue/forms/resolvers/zod';
  import { ref } from 'vue';
  import {
    SupplierTokenFormData,
    supplierTokenFormValidator,
  } from './SupplierTokenForm.types';
  import { reactive } from 'vue';
  import Form, { FormSubmitEvent } from '@primevue/forms/form';

  const initialValues = reactive({
    name: '',
    expiresInDays: null,
  });

  const resolver = ref(zodResolver(supplierTokenFormValidator));
  const formRef = ref<InstanceType<typeof Form> | null>();

  defineExpose({
    submit() {
      (formRef.value as any)?.submit();
    },
  });

  const emit = defineEmits<{
    (e: 'form-submit', form: FormSubmitEvent<SupplierTokenFormData>): void;
  }>();

  function onFormSubmit(form: FormSubmitEvent) {
    if (!form.valid) return;
    emit('form-submit', form as FormSubmitEvent<SupplierTokenFormData>);
  }
</script>

<style scoped lang="scss">
  .p-formfield {
    margin-bottom: 1.5rem;
  }
</style>
